import {
  loadMedicationSelectionOffers,
  waitForMedicationSelectionOffers,
} from "src/utils/redux/slices/medicationSelectionOffers";
import { ActionHandler } from ".";

/**
 * Starts loading the medication selection offers without blocking, so the
 * pages before WAIT_FOR_MEDICATION_SELECTION_LOADED render immediately.
 */
export const startLoadingMedicationSelection: ActionHandler = ({ store }) => {
  loadMedicationSelectionOffers(store.dispatch);
};

/** Waits for the pending medication selection offers load (if any). */
export const waitForMedicationSelectionLoaded: ActionHandler = () =>
  waitForMedicationSelectionOffers();
